(() => {
  'use strict';
  const catalog = window.DV_NATIVE_CATALOG;
  if (!catalog || !document.documentElement.hasAttribute('data-dv-native-preview')) return;
  const preview = catalog.previewTheme;
  let searchVariantPrices = null;
  function currentSearchVariantPrices() {
    if (searchVariantPrices) return searchVariantPrices;
    const data = document.querySelector('[data-dv-search-variant-prices]');
    if (!data) return null;
    try {
      searchVariantPrices = new Map(JSON.parse(data.textContent).map(item => [item.handle, item.variants]));
    } catch (_) { return null; }
    return searchVariantPrices;
  }
  function intendedSearchStone(handle) {
    for (const product of catalog.products || []) {
      for (const [stone, native] of Object.entries(product.native || {})) {
        if (native && native[2] === handle) return stone;
      }
    }
    return null;
  }
  function refreshPredictivePrices() {
    const prices = currentSearchVariantPrices();
    if (!prices) return;
    // SearchProductItem renders these exact cards inside the popup. Do not touch
    // full-page search, collection cards, or unknown products.
    document.querySelectorAll('[data-search-popup] [data-search-items-wrapper] [data-search-item]:not(.hidden) > a[href]').forEach(card => {
      let handle, cardUrl;
      try {
        cardUrl = new URL(card.getAttribute('href'), location.origin);
        if (cardUrl.origin !== location.origin) return;
        handle = /^\/products\/([^/]+)\/?$/.exec(cardUrl.pathname)?.[1];
      } catch (_) { return; }
      const stone = handle && intendedSearchStone(handle);
      const variants = handle && prices.get(handle);
      if (!stone || !variants) return;
      const titleStone = stone === 'pink' ? 'pink' : stone === 'white' ? 'white' : 'sapphire';
      const variant = variants.find(item => String(item.title || '').toLowerCase().includes(titleStone));
      if (!variant || !Number.isFinite(Number(variant.price))) return;
      const priceNode = card.querySelector('.text-color-regular-price .sf-currency');
      const compareContainer = card.querySelector('.text-color-sale-price');
      if (!priceNode || !compareContainer) return;
      if (priceNode.textContent !== variant.priceText) priceNode.textContent = variant.priceText;
      let compareNode = compareContainer.querySelector('.sf-currency');
      if (Number(variant.compareAt) > Number(variant.price)) {
        if (!compareNode) {
          compareNode = document.createElement('span');
          compareNode.className = 'sf-currency text-color-secondary text-sm line-through mr-2';
          compareContainer.appendChild(compareNode);
        }
        if (compareNode.textContent !== variant.compareText) compareNode.textContent = variant.compareText;
      } else if (compareNode) compareNode.remove();
      // Shopify's suggestion can attach a query-matched Pink variant to a
      // Sapphire/White alias. Keep this card's link, image, and corrected price
      // on the same current-product variant; leave campaign params and hash.
      if (cardUrl.searchParams.has('variant') && cardUrl.searchParams.get('variant') !== String(variant.id)) {
        cardUrl.searchParams.set('variant', String(variant.id));
        const nextHref = cardUrl.pathname + cardUrl.search + cardUrl.hash;
        if (card.getAttribute('href') !== nextHref) card.setAttribute('href', nextHref);
      }
      const image = card.querySelector('img');
      if (image && variant.image) {
        for (const name of ['srcset', 'data-src', 'data-srcset']) {
          if (image.hasAttribute(name) && image.getAttribute(name) !== variant.image) image.setAttribute(name, variant.image);
        }
        if (image.getAttribute('src') !== variant.image) image.setAttribute('src', variant.image);
        if (image.getAttribute('alt') !== variant.imageAlt) image.setAttribute('alt', variant.imageAlt);
      }
    });
  }
  function normalizeFullSearchVariant(link, url) {
    if (location.pathname !== '/search' || !link.closest('main .sf__pcard') || !url.searchParams.has('variant')) return;
    const handle = /^\/products\/([^/]+)\/?$/.exec(url.pathname)?.[1];
    const stone = handle && intendedSearchStone(handle);
    const variants = handle && currentSearchVariantPrices()?.get(handle);
    if (!stone || !variants) return;
    const token = stone === 'pink' ? 'pink' : stone === 'white' ? 'white' : 'sapphire';
    const variant = variants.find(item => String(item.title || '').toLowerCase().includes(token));
    if (variant) url.searchParams.set('variant', String(variant.id));
  }
  // Old shared collection links retain the same page, without the staging view in the address bar.
  if (window.DV_COMMERCE_EFFECTIVE_MODE === 'live' && /^\/collections\/(all|all-charms)\/?$/.test(location.pathname)) {
    const current = new URL(location.href);
    if (current.searchParams.get('view') === 'divetia-relaunch') {
      current.searchParams.delete('view');
      if (current.searchParams.get('dv_material') === 'all-charms') current.searchParams.delete('dv_material');
      history.replaceState(history.state, '', current.pathname + current.search + current.hash);
    }
  }
  function anchorsIn(root) {
    if (root.nodeType !== 1) return [];
    const found = Array.from(root.querySelectorAll('a[href]'));
    if (root.matches('a[href]')) found.unshift(root);
    return found;
  }
  function refresh(root) {
    const scope = root || document.documentElement;
    const anchors = root ? anchorsIn(root) : document.querySelectorAll('a[href]');
    anchors.forEach(a => {
      const raw = a.getAttribute('href');
      if (!raw || raw.startsWith('#') || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
      let url;
      try { url = new URL(raw, location.origin); } catch (_) { return; }
      if (url.origin !== location.origin || /\.(pdf|png|jpe?g|mp4|svg)$/i.test(url.pathname)) return;
      // Full search cards, like suggestions, describe the handle's stone.
      normalizeFullSearchVariant(a, url);
      // Restore the existing Bundler app instead of the replacement builder.
      if (/^\/pages\/gifting-studio\/?$/.test(url.pathname) && url.searchParams.get('view') === 'native-builder') {
        url.pathname = '/a/bundles/build-your-stack-glgt';
        url.searchParams.delete('view');
      }
      if (/^\/collections\/(all|all-charms)\/?$/.test(url.pathname)) {
        if (window.DV_COMMERCE_EFFECTIVE_MODE === 'live') {
          if (url.searchParams.get('view') === 'divetia-relaunch') url.searchParams.delete('view');
          if (url.searchParams.get('dv_material') === 'all-charms') url.searchParams.delete('dv_material');
        } else url.searchParams.set('view', 'divetia-relaunch');
      }
      if (window.DV_COMMERCE_EFFECTIVE_MODE === 'live') {
        url.searchParams.delete('preview_theme_id');
        url.searchParams.delete('dv_commerce');
      } else {
        url.searchParams.set('preview_theme_id', preview);
        if (window.DV_COMMERCE_EFFECTIVE_MODE === 'test') url.searchParams.set('dv_commerce', 'test');
      }
      const next = url.pathname + url.search + url.hash;
      if (a.getAttribute('href') !== next) a.setAttribute('href', next);
    });
    // Only replace exact shipping claims; do not alter returns or general copy.
    const nodes = [];
    if (scope.nodeType === 3) {
      if (document.body && document.body.contains(scope)) nodes.push(scope);
    } else if (document.body && (scope === document.documentElement || document.body.contains(scope))) {
      const walk = document.createTreeWalker(scope === document.documentElement ? document.body : scope, NodeFilter.SHOW_TEXT);
      while (walk.nextNode()) nodes.push(walk.currentNode);
    }
    nodes.forEach(node => {
      if (node.parentElement?.closest('script,style,textarea,input,[data-dv-native-preserve-text]')) return;
      const old = node.nodeValue;
      const next = old
        .replace(/Insured U\.S\. shipping is \$19\.95 on orders below \$269\. Complimentary insured U\.S\. shipping is included on orders of \$269 or more\./g, 'Insured U.S. shipping is $12.95 for Standard (2–5 business days after shipment) or $19.95 for Priority (2–3 business days after shipment). Tracking and insurance are included on both.')
        .replace(/Complimentary insured U\.S\. shipping is available on orders \$269\+\. Orders below \$269 ship for \$19\.95\./g, 'Insured U.S. shipping is $12.95 (Standard) or $19.95 (Priority).')
        .replace(/Our current collection is crafted in solid \.925 sterling silver with a rhodium finish\. Rhodium gives the silver a bright appearance and adds tarnish resistance\./g, 'Our current collection is crafted in .925 sterling silver with a rhodium finish for a bright appearance and added resistance to tarnish. Select a stone on each charm page to see its details.')
        .replace(/Complimentary U\.S\. Shipping \$269\+/gi, 'Insured U.S. Shipping from $12.95')
        .replace(/Free U\.S\. shipping(?: on orders (?:over |of )?\$269\+?)?/gi, 'insured U.S. shipping from $12.95');
      if (old !== next) node.nodeValue = next;
    });
    refreshPredictivePrices();
  }
  // Open the fully staged native PDP instead of a legacy quick-view with live prices.
  document.addEventListener('click', event => {
    const button = event.target.closest('.sf-pqv__button[data-product-handle]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL('/products/' + encodeURIComponent(button.dataset.productHandle), location.origin);
    if (window.DV_COMMERCE_EFFECTIVE_MODE !== 'live') url.searchParams.set('preview_theme_id', preview);
    if (window.DV_COMMERCE_EFFECTIVE_MODE === 'test') url.searchParams.set('dv_commerce', 'test');
    if (window.DV_COMMERCE_EFFECTIVE_MODE !== 'live') url.searchParams.set('dv_material', 'silver');
    location.assign(url.pathname + url.search);
  }, true);
  // Performance: after the first full pass, re-check only nodes that were added
  // (and links whose href changed) instead of rescanning the whole page per mutation.
  let pending = false;
  const queued = new Set();
  function schedule(records) {
    records.forEach(record => {
      if (record.type === 'attributes' || record.type === 'characterData') queued.add(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType === 1 || node.nodeType === 3) queued.add(node);
      });
    });
    if (pending || !queued.size) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      const roots = Array.from(queued).filter(node => node.isConnected);
      queued.clear();
      const set = new Set(roots);
      roots.forEach(node => {
        for (let up = node.parentNode; up; up = up.parentNode) if (set.has(up)) return;
        refresh(node);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  else refresh();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
})();
